import type { GraphQLTaggedNode } from 'react-relay';

import { CollabDraftQuery } from './CollabDraftQuery.graphql.ts';

export const getCollabDraftQuery = (): GraphQLTaggedNode => CollabDraftQuery;
